import { render, staticRenderFns } from "./common-problem-english2.vue?vue&type=template&id=d0586c7a&scoped=true"
import script from "./common-problem-english2.vue?vue&type=script&lang=js"
export * from "./common-problem-english2.vue?vue&type=script&lang=js"
import style0 from "./common-problem-english2.vue?vue&type=style&index=0&id=d0586c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0586c7a",
  null
  
)

export default component.exports